import React, { useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import ProfileBasicDetails from "./profileBasicDetails";
import ProfileChangePassword from "./profileChangePassword";
import {
  Card,
  CardBody,
  CardHeader,
} from "./../../../../_metronic/_partials/controls";
import ProfileSecurity from "./profileSecurity";
import ProfileAccount from "./profileAccount";

export function ProfileSettings() {
  const [selectedTab, setSelectedTab] = useState("basic-details");
  const handleSelect = (key) => {
    setSelectedTab(key);
  };
  return (
    <>
      <Card>
        <CardHeader title="Profile Settings"></CardHeader>
        <CardBody className="profile-seeting-tab">
          <Tabs
            defaultActiveKey="basic-details"
            id="OrderManagementTab"
            className="def_tab"
            onSelect={handleSelect}
          >
            <Tab eventKey="basic-details" title="Basic Details">
              <div className="p-6 bg-dark">
                <ProfileBasicDetails selectedTab={selectedTab} />
              </div>
            </Tab>
            {/*  <Tab eventKey="security" title="Security">
              <div className="p-6">
                <ProfileSecurity />
              </div>
            </Tab> */}
            <Tab eventKey="change-password" title="Change Password">
              <div className="p-6 bg-dark">
                <ProfileChangePassword selectedTab={selectedTab} />
              </div>
            </Tab>
            {/* <Tab eventKey="account" title="Account">
              <div className="p-6">
                <ProfileAccount  selectedTab={selectedTab}/>
              </div>
            </Tab> */}
          </Tabs>
        </CardBody>
      </Card>
    </>
  );
}
